import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { arrayOf, func, shape, string } from 'prop-types';

import LabelContent from './label-content';
import StyledLabel from './styled-label';

const LabelBuilderComponent = (
  {
    accessibility_text,
    text,
    values = null,
    styles = null,
    class_name = null,
    html_tag = null,
    onClick = null,
    url = null,
    id,
    target,
    sourceIcons,
  },
  ref,
) => {
  const [content, setContent] = useState(values);

  useEffect(() => {
    setContent(values);
  }, [values]);

  // TODO: check if this function is necessary or if it can be simplified
  const handleContent = () => ({
    changeValue(key, value) {
      const newContent = content.map((v) => {
        if (v.key !== key) {
          return v;
        }

        return { ...v, text: value };
      });

      setContent(newContent);
    },
    getValue(key) {
      const value = content.find((v) => v.key === key);

      return value;
    },
  });

  useImperativeHandle(ref, handleContent);

  if (!content) {
    return (
      <StyledLabel
        text={accessibility_text ?? text}
        styles={styles}
        className={class_name?.toLowerCase()}
        html_tag={html_tag}
        onClick={onClick}
        href={url}
        id={id}
        target={target}
      />
    );
  }

  return (
    <LabelContent text={text} content={content} styles={styles} class_name={class_name} sourceIcons={sourceIcons} />
  );
};

const LabelBuilder = forwardRef(LabelBuilderComponent);

LabelBuilderComponent.propTypes = {
  accessibility_text: string,
  class_name: string,
  html_tag: string,
  id: string,
  sourceIcons: shape({
    [string]: shape({
      Component: func,
      kind: string,
    }),
  }),
  styles: shape({
    [string]: string,
  }),
  target: string,
  text: string,
  url: string,
  values: arrayOf(
    shape({
      text: string,
      type: string, // 'HIGHLIGHT',
      key: string,
      styles: shape({}),
    }),
  ),
  onClick: func,
};

export default LabelBuilder;
